import { useFilter } from "../../../fetch/fetch.filter";
import { EMPTY_FILTER } from "../../../const/typeDefault/Filter";
import LoadingInput from "../../core/loading/LoadingInput";
import ErrMessage from "../../core/ErrMessage";
import FilterTitle from "../core/FilterTitle";
import RangeFilter from "./RangeFilter";
import SingleFilter from "./SingleFilter";
import MultiFilter from "./MultiFilter";
import FilterValue from "./FilterValue";
import { useSearchParamsHandler } from "../../../hooks/useSearchParamsHandler";
import { FILTER_OUTPUT } from "../../../types/Filter.ts";
import FilterIcon from "../core/FilterIcon.tsx";

const FilterCollapse = ({ id }: { id: string }) => {
  const { isActive } = useSearchParamsHandler("filter");
  const { filter, isLoading, isError } = useFilter(id, EMPTY_FILTER);
  if (isError) {
    return <ErrMessage message={isError.message} />;
  }
  if (isLoading) {
    return <LoadingInput />;
  }

  return (
    <>
      <div className="collapse-title font-bold text-xl flex items-center gap-2">
        <FilterIcon id={id} />
        <FilterTitle id={id} />
        <div
          className={`badge ${isActive(filter._id) && "badge-info justify-end-safe truncate"}`}
        >
          <p className="truncate">
            <FilterValue filterId={id} />
          </p>
        </div>
      </div>
      <div className="collapse-content ">
        {filter.outputType === FILTER_OUTPUT.SINGLE && (
          <SingleFilter filter={filter} />
        )}
        {filter.outputType === FILTER_OUTPUT.RANGE && (
          <RangeFilter filter={filter} />
        )}
        {filter.outputType === FILTER_OUTPUT.MULTI && (
          <MultiFilter filter={filter} />
        )}
      </div>
    </>
  );
};
export default FilterCollapse;
